import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { MapContext } from '../models';
import { DemographicReportView } from './demo-report-view';
import { domesticMapping, internationalMapping } from './reports-mapping';



export function DemographiReports() {

	const mapContext = useSelector<TcsmStates, MapContext>(state => state?.clergyCompReportState?.mapContext);
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state.epiProps.clergyCompReportSettingsState.epiContent);

	return (

		<>
			{
				mapContext === MapContext.INTERNATIONAL ?
					<DemographicReportView
						data={
							settings.internationalDemographicReportJson ?
								JSON.parse(settings.internationalDemographicReportJson) :
								internationalMapping
						}
					/>
					:
					<DemographicReportView
						data={
							settings.domesticDemographicReportJson ?
								JSON.parse(settings.domesticDemographicReportJson) :
								domesticMapping
						}
					/>
			}

		</>
	);
}